<div class="container">
    <div class="row">
        <div class="col section-title-full">
            <h1>
                <span i18n>Detalle de ticket</span>
            </h1>
        </div>
    </div>
</div>

<div class="container">
    <div class="row my-5" *ngIf="ticket">
        <div class="col">
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">Volver</button>
            <div class="row">
                <div class="col-12">
                    <h2 class="my-4"><span i18n>Asunto</span>: {{ticket.subject}}</h2>
        
                    <div class="card">
                        <div class="col-12">
                            <table class="table table-responsive table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col" i18n>Interlocutor</th>
                                        <th scope="col" i18n>Mensaje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let message of ticket.messages">
                                        <td>{{message.user.username}}</td>
                                        <td>{{message.message}}</td>
                                    </tr>
                                    <tr *ngIf="ticket.messages.length == 0">
                                        <td colspan="2" class="text-center" i18n>No hay mensajes</td>
                                    </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-5">
        <div class="col text-center">
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()" i18n>Volver</button>
        </div>
    </div>
</div>